
export class STATUS_CODE {
  static OK = 200;
  static BAD_REQUEST = 400;
  static NOT_FOUND = 404;
  static UNAUTHORIZED = 401;
  static NOT_ACCEPTABLE = 406;
  static SERVER_ERROR = 500
}

